import { CachedChartActionTypes } from "models/actionTypes/cachedChartActionTypes";
import { CachedChartItem } from "models/stateTypes/cachedChartsState";
import { ReduxConstants } from "utils/constants";

export const setCachedChart = (chart: CachedChartItem): CachedChartActionTypes => {
  return {
    type: ReduxConstants.CachedChartsActions.SET_CACHED_CHART,
    payload: chart,
  };
};

export const resetCachedCharts = (): CachedChartActionTypes => {
  return {
    type: ReduxConstants.CachedChartsActions.RESET_CACHED_CHARTS,
  };
};
